import React from 'react';

import {
  StyledIcon,
  StyledItem,
  StyledLink,
  StyledList,
  StyledText,
  StyledWrapper,
} from './Breadcrumb.styles';

interface IItemsProps {
  href: string;
  label: string;
  id: string;
}

interface IBreadcrumbProps {
  items: IItemsProps[];
}

export const Breadcrumb = ({ items }: IBreadcrumbProps) => {
  const linkListLength = items.length;

  return (
    <StyledWrapper
      forwardedAs="section"
      width={{ laptop: 'xl', tabletLandscape: 'l' }}
    >
      <nav role="navigation" aria-label="Breadcrumb">
        <StyledList itemScope itemType="https://schema.org/BreadcrumbList">
          {items.map((item, index) => {
            const isLast = index === linkListLength - 1;
            const contentIndex = `${index + 1}`;

            return (
              <StyledItem
                key={item.id}
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                {isLast ? (
                  <>
                    <StyledText itemProp="name">{item.label}</StyledText>
                    <meta itemProp="position" content={contentIndex} />
                  </>
                ) : (
                  <>
                    <StyledLink href={item.href} itemProp="item">
                      <span itemProp="name">{item.label}</span>
                    </StyledLink>
                    <meta itemProp="position" content={contentIndex} />
                    <StyledIcon />
                  </>
                )}
              </StyledItem>
            );
          })}
        </StyledList>
      </nav>
    </StyledWrapper>
  );
};
